import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { decryptAES } from "../../../utils/EncryptorUtils";
import { useNavigation } from "../../../hooks/useNavigation";
import { useAuthSlice } from "../../../redux/slice/authSlice";
import ExternalAccessLayout from "../../common/ExternalAccessLayout";
import ExternalAccessSignInDialog from "../../common/ExternalAccessSignInDialog";
// Reload popup code intentionally kept commented for future reuse.
// import SimpleReleasePopup from "../../common/SimpleReleasePopup";
// import { useAppDispatch } from "../../../redux/slice/redux-hooks";
// import { fetchAppVersion } from "../../../redux/slice/userSlice";
// import { getDataFromCookies, setDataToCookies } from "../../../utils/StorageUtils";
// import { TokenString } from "../../../types/CommonTypes";
// import { retrieveDataFromTokenCookie } from "../../../utils/Utility";

const InvoiceSharingAccess: React.FC = () => {
  const { navigate } = useNavigation();
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const { isValid } = useAuthSlice();
  const [email, setEmail] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  // const dispatch = useAppDispatch();
  // const [showReleasePopup, setShowReleasePopup] = useState(false);
  // const [releaseNoteShown, setReleaseNoteShown] = useState(false);
  // const [backendVersion, setBackendVersion] = useState("");

  useEffect(() => {
    // Parse the URL parameters
    const params = new URLSearchParams(location.search);
    const encryptedInvoiceNumber = params.get("invoiceNumber") || null;
    const encryptedEmail = params.get("email") || null;
    const iv = params.get("iv");
    const salt = params.get("salt");

    // Decrypt the parameters
    if (encryptedInvoiceNumber != null && encryptedInvoiceNumber !== "") {
      setInvoiceNumber(decryptAES(encryptedInvoiceNumber, iv, salt));
    }
    if (encryptedEmail != null && encryptedEmail !== "") {
      setEmail(decryptAES(encryptedEmail, iv, salt));
    }
  }, [location.search]);

  useEffect(() => {
    // If user is already logged in and email matches, navigate to invoice list
    if (
      isValid &&
      invoiceNumber !== ""
    ) {
      navigate("/invoice_list", {
        state: { mfgInvoiceNumber: invoiceNumber },
        replace: true,
      });
    } else if (invoiceNumber !== "") {
      setShowPopup(true);
    }
  }, [isValid, invoiceNumber, email]);

  // Reload popup flow intentionally disabled.
  // useEffect(() => {
  //   const checkVersion = async () => {
  //     try {
  //       const response = await dispatch(fetchAppVersion({ skipLoader: true }));
  //       const serverVersion = response.payload?.applicationVersion;
  //       if (serverVersion) {
  //         setBackendVersion(serverVersion);
  //         const storedVersion = localStorage.getItem("applicationVersion");
  //         const releaseNoteSessionKey = "invoiceSharingReleaseNoteShown";
  //         const hasShownInSession = sessionStorage.getItem(releaseNoteSessionKey);
  //         const shouldShowPopup = !releaseNoteShown && ((!storedVersion && serverVersion) || !hasShownInSession);
  //         const shouldNotShow = storedVersion === serverVersion && hasShownInSession === "true";
  //         if (shouldShowPopup && !shouldNotShow) {
  //           setShowReleasePopup(true);
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error checking version:", error);
  //     }
  //   };
  //   checkVersion();
  // }, [dispatch, releaseNoteShown]);

  // const handleReloadNow = () => {
  //   const releaseNoteSessionKey = "invoiceSharingReleaseNoteShown";
  //   const storedVersion = localStorage.getItem("applicationVersion");
  //   if (backendVersion && (!storedVersion || storedVersion !== backendVersion)) {
  //     localStorage.setItem("applicationVersion", backendVersion);
  //   }
  //   const token = getDataFromCookies("token");
  //   let data: TokenString = retrieveDataFromTokenCookie(token);
  //   data.token = "";
  //   setDataToCookies("token", JSON.stringify(data));
  //   setReleaseNoteShown(true);
  //   setShowReleasePopup(false);
  //   sessionStorage.setItem(releaseNoteSessionKey, "true");
  //   window.location.reload();
  // };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      <ExternalAccessLayout
        title="Invoice Access"
        description="Please sign in to view the shared invoice(s)."
      />

      {showPopup && (
        <ExternalAccessSignInDialog
          onClose={handleClosePopup}
          email={email}
          allowEmailEdit={true}
          title="Invoice Access"
          description="Please enter your password to access the shared invoice(s)"
          submitButtonLabel="Access Invoices"
          onAuthorized={() => {
            navigate("/invoice_list", {
              state: { mfgInvoiceNumber: invoiceNumber.trim() },
              replace: true,
            });
          }}
        />
      )}
      {/* {showReleasePopup && (
        <SimpleReleasePopup
          open={showReleasePopup}
          onReloadNow={handleReloadNow}
        />
      )} */}
    </>
  );
};

export default InvoiceSharingAccess;
